<template>
  <div>
    <div>
      <el-button type="primary" @click="submit" size="small">保存</el-button>
      <el-button @click="$emit('close')" size="small">取消</el-button>
    </div>
    <el-form ref="formRef" :model="openForm" label-width="120px" class="FormCl" :rules="rule">
      <el-form-item label="RFID：" size="small" prop="rework_rfid_no">
        <el-input ref="cardRef" v-model="openForm.rework_rfid_no" :disabled="openForm.rework_rfid_no.length === 10">
          <template slot="append">
            <el-link type="primary" class="vg_pointer" @click="emptyChange">清空</el-link>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="样品编号：" size="small" prop="samp">
        <el-input v-model="openForm.samp" :disabled="true" placeholder="请选择样品编号">
          <template slot="append">
            <el-link type="primary" class="vg_pointer" @click="dialogVisible = true">选择</el-link>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <el-dialog @opened="getDialogData" title="选择重做货号" :visible.sync="dialogVisible" width="40%" append-to-body top="0">
      <search-table
        ref="searchTable"
        :need-search="true"
        :need-fixed-height="false"
        :data="dialogTableData"
        :tableRowKey="'id'"
        :total-page="dialogTotalPage"
        :page-size="10"
        :columns="dialogTableProperties"
        :need-pagination="true"
        :columnMove="false"
        :dbClickJp="
          row => {
            dialogVisible = false;
            openForm.samp = row.smpl_no;
            openForm.smpl_id = row.smpl_id;
          }
        "
        @getTableData="getDialogData"
      />
    </el-dialog>
  </div>
</template>

<script>
import { get, getNoCatch } from '@api/request';
import { smplAPI } from '@api/modules/smpl'; //getSmpls
import { reworkRfidAPI } from '@api/modules/rfid'; //rfid
import pubPagination from '@/components/common/pubPagination';
import SearchTable from '@/components/SearchTableV3.vue';

export default {
  name: 'openCard',
  components: {
    SearchTable,
    pubPagination
  },
  mounted() {
    this.$refs.cardRef.focus();
  },
  created() {
    this.getSampList();
  },
  data() {
    return {
      openForm: {
        rework_rfid_no: '',
        samp: '', //显示
        smpl_id: '' //样品编号id
      },
      rule: {
        rework_rfid_no: [{ required: true, trigger: 'blur', message: ' ' }],
        samp: [{ required: true, trigger: 'blur', message: ' ' }]
      },
      dialogSampVisible: false,
      SampList: [], //样品
      SampTotal: 0,
      title: ' 提示：(双击表编对应数据即可选中人员)',
      searchSampForm: {
        page_no: 1,
        smpl_no: null
      },
      loadingFlag: true,
      dialogVisible: false,
      dialogTotalPage: 0,
      dialogTableData: [],
      dialogTableProperties: [
        { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
        { prop: 'requ_no', label: '委托单号', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { prop: 'smpl_no', label: '样品编号', itemType: 'input', input: true, sortable: false, widthAuto: true },
        { prop: 'smpl_suffix', label: '更改号', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { prop: 'smpl_name', label: '样品名称', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { prop: 'smpl_stff_name', label: '开版师', itemType: 'input', input: true, sortable: false, widthAuto: true },
        { prop: 'smpl_type', label: '样品类型', itemType: 'input', input: false, sortable: false, widthAuto: true }
      ]
    };
  },
  methods: {
    //获取样品数据
    getSampList() {
      get(smplAPI.get_all_smpls_v1, this.searchSampForm)
        .then(res => {
          if (res.data.code !== 0) {
            return console.log('数据请求失败');
          }
          this.SampList = res.data.data.list;
          this.SampTotal = res.data.data.total;
          setTimeout(() => {
            this.loadingFlag = false;
          }, 300);
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    submit() {
      if (!this.openForm.rework_rfid_no) {
        return this.$message.warning('Rfid不可为空');
      }
      if (!this.openForm.smpl_id) {
        return this.$message.warning('样品编号不可为空');
      }
      this.$confirm('是否开卡?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          reworkRfidAPI.addReworkRfidItem(this.openForm).then(() => {
            this.$message.success('开卡成功!');
            this.$emit('close');
          });
        })
        .catch(() => {});
    },
    cancel() {
      this.$confirm('取消开卡, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.jump('open_list');
        })
        .catch(() => {});
    },
    emptyChange() {
      this.openForm.rework_rfid_no = '';
      this.$nextTick(() => {
        this.$refs.cardRef.focus();
      });
    },
    getDialogData() {
      getNoCatch(smplAPI.chooseToRedoData, this.$refs.searchTable.searchForm).then(({ data }) => {
        this.dialogTableData = data.list;
        this.dialogTotalPage = data.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 10px;
}
.FormCl {
  width: 70%;
  margin: 0 auto;
}
</style>
